import React from 'react';
import CustomModal from '../../components/customMessageModal/customMsgModal';

type CustomerServiceModalProps = {
  isOpen: boolean;
  onClose: () => void;
  docId: string;
  customerId: string;
  wizardType: string;
};

export const CustomerServiceModal: React.FC<CustomerServiceModalProps> = ({
  isOpen,
  onClose,
  docId,
  customerId,
  wizardType
}) => {
  let message = 'Please contact Customer Service';

  if (wizardType === 'CustomPatchesVintage') {
    message = 'Please contact Customer Service to order this product';
  } else {
    message = 'For reorders of this design, please contact Customer Service';
  }

  const formattedMessage = (
    <div className="flex flex-col text-sm gap-y-[1em]">
      <span>
        {message}
      </span>
      <span>
        <strong>Order Design ID:</strong> {docId}<br />
        <strong>Customer ID:</strong> {customerId}
      </span>
      <span >
        Stahls Canada customer service phone# <b>800.521.5255</b>
      </span>
    </div>
  );

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      title='Notice'
      formattedMessage={formattedMessage}
      onConfirm={onClose}
      confirmButtonText="Ok"
      showCancelButton={false}
      isCustomerView={false}
    />
  );
};